var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "d-flex flex-column align-center pa-6 pa-sm-12"
  }, [_c('div', {
    staticClass: "title mb-12"
  }, [_vm._v("Nothing found at this URL")]), _c('div', {
    staticClass: "d-flex justify-center flex-wrap ma-n2"
  }, _vm._l([['catalog', _vm.mdiCards, 'View all cards'], ['catalog-video', _vm.mdiVideoVintage, 'View all video themes']].concat(_vm.global.xgc ? [] : [['catalog-gift-cards', _vm.mdiWalletGiftcard, 'View all gift cards']]), function (_ref) {
    var name = _ref[0],
      icon = _ref[1],
      title = _ref[2];
    return _c('v-btn', {
      key: name,
      staticClass: "ma-2",
      staticStyle: {
        "text-transform": "none"
      },
      attrs: {
        "text": "",
        "color": "pink",
        "to": {
          name
        }
      }
    }, [_c('v-icon', {
      staticClass: "mr-2",
      domProps: {
        "innerHTML": _vm._s(icon)
      }
    }), _vm._v(_vm._s(title) + " ")], 1);
  }), 1), _vm._m(0), _c('v-spacer')], 1);

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "mt-12 text-center"
  }, [_vm._v(" Think you're seeing this page in error? Please let us know!"), _c('br'), _c('a', {
    attrs: {
      "href": "mailto:support@ellacard.com"
    }
  }, [_vm._v("support@ellacard.com")])]);

}]

export { render, staticRenderFns }